import { endpoints, REQUEST_METHODS } from '../constants';
import { adminApiSlice } from '../store';

export const adminAuthService = adminApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    authenticateAdmin: builder.mutation({
      query: (values) => ({
        url: endpoints.admin.login,
        method: REQUEST_METHODS.POST,
        body: values
      })
    }),
    logoutAdmin: builder.mutation({
      query: () => ({
        url: endpoints.admin.logout,
        method: REQUEST_METHODS.POST
      })
    }),
    getAdminProfile: builder.query({
      query: () => ({
        url: endpoints.admin.profile,
        method: REQUEST_METHODS.GET
      })
    })
  })
});

export const {
  useAuthenticateAdminMutation,
  useLogoutAdminMutation,
  useGetAdminProfileQuery
} = adminAuthService;
